// Why a credit was closed with no credit document behind it.
//
// SYNC PAIR: `server/lib/creditClose.js` (CLOSE_REASONS). The server VALIDATES
// the key and renders the Hebrew label for every read path (closed_reason_label
// on each credit row); this copy exists only so the chip selector has something
// to draw before the request is made. Change one → change the other, or the UI
// offers a chip the server rejects with a 400.
//
// The KEY is what gets stored. The label is display copy and will be reworded;
// storing it instead would make every rewording a data migration. Unlike the
// credit STATUSES (פתוח/התקבל/בוטל), these Hebrew strings are not DB enum
// values — that is the whole distinction this file rests on.
export const CREDIT_CLOSE_REASONS = [
  // The money came back, just not as a חשבונית זיכוי — taken off the next
  // invoice, or handed over in cash.
  { key: 'received_no_doc',       label: 'התקבל זיכוי בפועל' },
  // Agreed with the supplier that the claim is settled, with nothing issued.
  { key: 'settled_with_supplier', label: 'סוכם מול הספק — ללא מסמך' },
  // We dropped the claim: nobody owes anything now, and nobody paid.
  { key: 'waived',                label: 'ויתרנו על הזיכוי' },
  // Never should have existed (mis-keyed quantity, duplicate). Without it the
  // only fitting option is 'waived', which claims we were owed and gave it up.
  { key: 'opened_by_mistake',     label: 'נפתח בטעות' },
];

export const CREDIT_CLOSE_REASON_KEYS = CREDIT_CLOSE_REASONS.map(r => r.key);
